module.exports = __webpack_public_path__ + "static/media/tachometer-alt-average.274cd097.svg";